import styled from '@emotion/styled';
import React, { useEffect, useRef, useState } from 'react';
import LandingPageSection from './LandingPageSection';
import Section1Content from './SectionContent/Section1Content';
import SectionPainPointContent from './SectionContent/SectionPainPointContent';
import Section2Content from './SectionContent/Section2Content';
import Section3Content from './SectionContent/Section3Content';
import NavBar from '../../../components/NavBar/NavBar';
import AboutContent from './SectionContent/AboutContent';

const LandingPageWrapper = styled.div<{
    hasLoaded: boolean;
}>`
    margin: 0;
    padding: 0;
    width: 100%;

    // fade in animation for LandingPageSections
    & > div {
        opacity: ${p => p.hasLoaded ? '1' : '0'};
        bottom: ${p => p.hasLoaded ? '0' : '-50px'};
        transition: opacity 1s ease, left 1s ease, bottom 1s ease;
        position: relative;
    }

    // fade in animation for left side of content
    & > div > div:first-of-type {
        opacity: ${p => p.hasLoaded ? '1' : '0'};
        bottom: ${p => p.hasLoaded ? '0' : '-15px'};
        transition: opacity 1s ease, left 1s ease, bottom 1s ease;
        position: relative;
    }

    // fade in animation for right side of content
    & > div > div:last-of-type {
        opacity: ${p => p.hasLoaded ? '1' : '0'};
        bottom: ${p => p.hasLoaded ? '0' : '-15px'};
        transition: opacity 2s ease, left 2s ease, bottom 2s ease;
        position: relative;
    }
`;

interface LandingPageProps {

}

const LandingPage: React.FC<LandingPageProps> = () => {
    const [hasLoaded, setHasLoaded] = useState<boolean>(false);
    const [currentTab, setCurrentTab] = useState<string>('product');

    useEffect(() => {
        setHasLoaded(true);
    }, []);

    const wrapperRef = useRef<any>();

    const handleNavigate = (newTab: string) => {
        setHasLoaded(false);
        setTimeout(() => {
            setCurrentTab(newTab);
            setHasLoaded(true);
        }, 200);
    };

    const handleContactUs = () => {
        const homepageElm = document.getElementsByClassName('desktop-homepage')[0];
        handleNavigate('contact');
        setTimeout(() => {
            homepageElm.scrollTo({
                top: 0,
                behavior: "smooth",
            });
        }, 250);
    };

    const MainContent = (
        <LandingPageWrapper hasLoaded={hasLoaded} ref={wrapperRef}>
            <LandingPageSection>
                <Section1Content />
            </LandingPageSection>
            <LandingPageSection>
                <SectionPainPointContent />
            </LandingPageSection>
            <LandingPageSection>
                <Section2Content />
            </LandingPageSection>
            <LandingPageSection>
                <Section3Content onContactUsClick={handleContactUs}/>
            </LandingPageSection>
        </LandingPageWrapper>
    );

    const ContactContent = (
        <LandingPageWrapper hasLoaded={hasLoaded} ref={wrapperRef}>
            <LandingPageSection>
                <AboutContent />
            </LandingPageSection>
        </LandingPageWrapper>
    );

    return (
        <>
            <NavBar currentTab={currentTab} onNavigate={(newTab) => {handleNavigate(newTab)}} onGetInTouchClick={() => handleNavigate('contact')}/>
            <LandingPageWrapper hasLoaded={hasLoaded}>
                {currentTab === 'product' ? MainContent : ContactContent}
            </LandingPageWrapper>
        </>
    );
};

export default LandingPage;
